export const instantAccessItems: string[] = [
  'Tutti gli 8 volumi completi, pronti da stampare',
  '2.752 esercizi con nome, materiale, durata e livello di difficoltà',
  'Percorso pronto dalla classe 1ª primaria alla 5ª superiore',
  'Schede pronte all’uso, senza bisogno di formazione sportiva',
  'Griglie di valutazione e descrittori del voto già compilati',
  'Attività eseguibili anche senza palestra e senza attrezzi',
  'Nessun abbonamento: accesso immediato e permanente',
]
